import {
  Component,
  EventEmitter,
  Input,
  Output,
  ViewEncapsulation,
} from '@angular/core';

import { SelectionType } from '../../models/selection-type.enum';
import { PlatformEnum } from '@panamax/app-state';

@Component({
  selector: 'app-new-search-operations',
  templateUrl: './new-search-operations.component.html',
  styleUrls: ['./new-search-operations.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class NewSearchOperationsComponent {
  @Input() selection: SelectionType;
  @Input() SelectionType: typeof SelectionType;
  @Input() isGuestUser: boolean;
  @Input() showInventory: boolean;
  @Input() showAddToList: boolean;
  @Input() showAddIngredient: boolean;
  @Input() platform: PlatformEnum;

  @Output() compareProducts = new EventEmitter();

  readonly platformEnum = PlatformEnum;

  constructor() {}

  handleSelectionTypeChange(selectionType: SelectionType) {
    this.compareProducts.emit(selectionType);
  }
}
